import React, { useState } from 'react';
import * as api from '../lib/api';
import type { UserIdentity } from '../types';

interface Props {
  user: UserIdentity;
  onClose: () => void;
  onAdded: () => void;
}

export function AddAdventureModal({ user, onClose, onAdded }: Props) {
  const [desc, setDesc] = useState('');
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!desc.trim() || !comment.trim()) return;
    setSaving(true);
    const ok = await api.addAdventure(desc.trim(), comment.trim());
    setSaving(false);
    if (ok) onAdded();
    else alert('Failed to create adventure.');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4"
         onClick={onClose}>
      <div className="card p-6 w-full max-w-lg space-y-4" onClick={e => e.stopPropagation()}>
        <h2 className="font-display text-2xl text-sand-900">New Adventure</h2>

        <div>
          <label className="block text-sm font-medium text-sand-600 mb-1">Description</label>
          <input className="input" value={desc} onChange={e => setDesc(e.target.value)} autoFocus placeholder="e.g. Italy 2025" />
        </div>

        <div>
          <label className="block text-sm font-medium text-sand-600 mb-1">Comment</label>
          <textarea className="input min-h-[140px]" value={comment} onChange={e => setComment(e.target.value)}
                    placeholder="Details about this adventure..." />
        </div>

        <div className="flex gap-3 justify-end pt-2">
          <button onClick={onClose} className="btn-secondary">Cancel</button>
          <button onClick={handleSave} disabled={!desc.trim() || !comment.trim() || saving} className="btn-primary">
            {saving ? 'Creating...' : 'Create Adventure'}
          </button>
        </div>
      </div>
    </div>
  );
}
